// The Ember mark: a flame with a cut-out core. Colours come from the theme,
// so it follows light/dark automatically. `onAccent` draws it on an
// accent-coloured surface (the primary button).

export default function FlameMark({ size = 30, tone = 'accent' }: { size?: number; tone?: 'accent' | 'onAccent' }) {
  const flame = tone === 'accent' ? 'var(--color-accent)' : 'var(--color-on-accent)';
  const core = tone === 'accent' ? 'var(--color-bg)' : 'var(--color-accent)';
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path
        d="M16 3c1.5 5 7 7.5 7 14a7 7 0 0 1-14 0c0-3.2 1.6-5.6 3.4-7.2.4 2.4 1.6 3.9 3.1 4.4C14.8 10.5 15 6.5 16 3z"
        fill={flame}
      />
      <path d="M16 29a3.6 3.6 0 0 1-3.6-3.6c0-2 1.6-3.2 3.6-5.4 2 2.2 3.6 3.4 3.6 5.4A3.6 3.6 0 0 1 16 29z" fill={core} />
    </svg>
  );
}
